import React, { useEffect, useRef, useState } from "react";
import classes from "./style.module.scss";
import ModalDropdown from "../../component/ModalDropdown";
import CloseIcon from "@mui/icons-material/Close";
import SelectBox from "../../component/SelectBox";
import Button from "../../component/Button";
import { Controller, FormProvider, useForm } from "react-hook-form";
import InputBox from "../../component/InputBox";
import FileUpload from "../../component/FileUpload";
import Exported from "../../service/endpoints";
import request from "../../service";
import { Toast } from "../../service/toast";
import { saveLoadingState } from "../../redux/reducers/loadingSlice";
import { useDispatch } from "react-redux";
import { singleUpload } from "../../helpers";
import GetUserPermission from "../../component/GetUserPermission";
import { useNavigate } from "react-router-dom";
import { KG_BEARINGS, KG_BULK_FILTRATION, KG_FILTERS, KG_PROMO, KG_TRUCK_SOLUTIONS } from '../../helpers';

const statusOptions = [
  { label: KG_FILTERS, value: 3 },
  { label: KG_TRUCK_SOLUTIONS, value: 4 },
  { label: KG_BEARINGS, value: 1 },
  { label: KG_BULK_FILTRATION, value: 2 },
];

const UploadResources = (props) => {
  const {
    isOpen = false,
    closePopUp,
    activeTab,
    resourceId,
    handleSuccessModal,
  } = props;
  const selectBoxRef = useRef();
  const ACTIVE = "Active";
  const IN_ACTIVE = "Inactive";
  const statusList = [
    { label: ACTIVE, value: ACTIVE },
    { label: IN_ACTIVE, value: IN_ACTIVE },
  ];
  const formMethods = useForm({
    mode: "onSubmit",
  });
  const {
    handleSubmit,
    formState: { errors },
    register,
    setValue,
    trigger,
  } = formMethods;

  const [fileName, setFileName] = useState(null);
  // const [productOptions, setProductOptions] = useState(null);
  // const [applicationOptions, setApplicationOptions] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState(null);
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [selectedButton, setSelectedButton] = useState([]);
  const addPermission = GetUserPermission({ key: 'add', microAppPath: 'rewards' });
  const editPermission = GetUserPermission({ key: 'edit', microAppPath: 'rewards' });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const tagsList = [
    { label: "Top Trending", value: 1 },
    { label: "Highlights", value: 2 },
  ]

  const handleButtonClick = (button) => {
    setSelectedButton((prevSelectedButtons) => {
      if (prevSelectedButtons.includes(button)) {
        return prevSelectedButtons.filter((b) => b !== button);
      } else {
        return [...prevSelectedButtons, button];
      }
    });
  };

  useEffect(() => {
    if (isEdit) {
      if (!editPermission) {
        closePopUp()
        redirectBack()
      }
    } else {
      if (!addPermission) {
        closePopUp()
        redirectBack()
      }
    }
  }, [isEdit])

  useEffect(() => {
    if (resourceId) {
      getDetails(resourceId);
      setIsEdit(true);
    } else {
      setIsEdit(false);
    }
    // getProductOptions();
    // getApplicationOptions();
  }, [resourceId]);

  const redirectBack = () => {
    navigate('')
  }

  // const getProductOptions = async () => {
  //   let url = `${Exported.Endpoints.getProduct}`;
  //   await request({
  //     url: url,
  //   })
  //     .then((res) => {
  //       if (res?.data?.status) {
  //         setProductOptions(
  //           res?.data?.data?.map((it) => ({
  //             label: it.reference_number,
  //             value: it.id,
  //           }))
  //         );
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err, "err");
  //       Toast({
  //         type: "error",
  //         message: "Unable to process the request!..",
  //       });
  //     });
  // };

  // const getApplicationOptions = async () => {
  //   let url = `${Exported.Endpoints.getApplication}`;
  //   await request({
  //     url: url,
  //   })
  //     .then((res) => {
  //       if (res?.data?.status) {
  //         setApplicationOptions(
  //           res?.data?.data?.map((it) => ({
  //             label: it.title,
  //             value: it.id,
  //           }))
  //         );
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err, "err");
  //       Toast({
  //         type: "error",
  //         message: "Unable to process the request!..",
  //       });
  //     });
  // };

  const getDetails = async (id) => {
    let url = `${Exported.Endpoints.getResourcesByID}/${id}`;
    let paramsObj = {
      id: id,
    };
    await request({
      url: url,
      params: { ...paramsObj },
    })
      .then((res) => {
        if (res?.data?.status) {
          let detailInfo = res?.data?.data;
          setValue("title", detailInfo?.title);
          setValue("producStatus", detailInfo?.status ? ACTIVE : IN_ACTIVE);
          setValue("description", detailInfo?.description);
          setValue("productName", detailInfo?.product_id || null);
          setValue("applicationStatus", detailInfo?.app_ids || null);
          setValue("uploadResource", detailInfo?.media_file || null);
          setFileName([detailInfo?.media_file]);
          setSelectedButton(detailInfo?.tags || [])
          setValue("categoryName", detailInfo?.category_id || null);        
        }
      })
      .catch((err) => {
        console.log(err, "err");
        Toast({
          type: "error",
          message: "Unable to process the request!..",
        });
      });
  };

  const onSubmit = async (data) => {
    trigger();
    dispatch(saveLoadingState(true));
    let uploadedObj = {};
    if (uploadedFiles && uploadedFiles.length > 0) {
      uploadedObj = await singleUpload(uploadedFiles);
    }
    let url = isEdit
      ? `${Exported.Endpoints.getResourcesByID}/${resourceId}`
      : `${Exported.Endpoints.getResourcesByID}`;
    let requestData = {
      title: data?.title,
      // product_id: data?.productName,
      description: data?.description,
      status: data?.producStatus == ACTIVE ? true : false,
      category_id: data?.categoryName,
    };
    if (!isEdit) {
      requestData["resource_type"] = parseInt(activeTab);
    }
    if(uploadedObj?.mimetype || uploadedObj?.url) {
      if (uploadedObj?.mimetype) {
        requestData["mimetype"] = uploadedObj?.mimetype;
      }
      if (uploadedObj?.url) {
        requestData["media_file"] = uploadedObj?.url;
      }
    } else if(data?.uploadResource) {
      requestData["media_file"] = data?.uploadResource
    }
    if(data?.applicationStatus) {
      requestData["app_ids"] = data?.applicationStatus
    }
    if(selectedButton?.length > 0) {
      requestData["tags"] = selectedButton
    }

    // console.log("Final Payload:", requestData);

    await request({
      url: url,
      method: isEdit ? Exported.APIMethods.PUT : Exported.APIMethods.POST,
      data: requestData,
    })
      .then((res) => {
        if (res?.data?.status) {
          dispatch(saveLoadingState(false));
          handleSuccessModal();
        }
      })
      .catch((err) => {
        console.log(err, "err");
        Toast({
          type: "error",
          message: "Unable to process the request!..",
        });
      });
    dispatch(saveLoadingState(false));
  };

  return (
    <>
      <ModalDropdown
        isOpen={isOpen}
        closePopUp={closePopUp}
        selectBoxRef={selectBoxRef}
      >
        <div className={`${classes.resourcesUploadWrapper}`}>
          <div
            className={`${classes.modalHeader} flex items-center justify-between`}
          >
            <div className={`${classes.modalTitle}`}>Upload Resource</div>
            <div className={`${classes.modalCloser}`}>
              <CloseIcon onClick={() => closePopUp()} />
            </div>
          </div>
          <div className={`${classes.reasonFormContainer}`}>
            <FormProvider {...formMethods}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className={`${classes.formField} !mb-5`}>
                  <InputBox
                    label={"Title"}
                    className={`w-[100%] ${classes.notesInput}`}
                    name={"title"}
                    {...register("title", {
                      required: true,
                    })}
                    placeholder={"Title"}
                    error={errors.title}
                    messages={{
                      required: "Title is required",
                    }}
                    isEdit={isEdit}
                  />
                </div>
                 <div className={`${classes.formField} !mb-5`}>
                  <Controller
                    name="categoryName"
                    control={formMethods?.control}
                    defaultValue=""
                    rules={{ required: true }}
                    render={({ field }) => (
                      <SelectBox
                        label="Product Category Name"
                        placeholder="Product Category Name"
                        list={statusOptions || []}
                        isEdit={isEdit}
                        searchBox={true}
                        {...field}
                        error={errors.categoryName}
                        messages={{
                          required: "Category Name is required",
                        }}
                      />
                    )}
                  />
                </div> 
                {/* <div className={`${classes.formField} !mb-5`}>
                  <Controller
                    name="productName"
                    control={formMethods?.control}
                    defaultValue=""
                    rules={{ required: true }}
                    render={({ field }) => (
                      <SelectBox
                        label="Product Name"
                        placeholder="Product Name"
                        list={productOptions || []}
                        isEdit={isEdit}
                        searchBox={true}
                        {...field}
                        error={errors.productName}
                        messages={{
                          required: "Product Name is required",
                        }}
                      />
                    )}
                  />
                </div> */}
                <div className={`${classes.formField} !mb-5`}>
                  <Controller
                    name="producStatus"
                    control={formMethods?.control}
                    defaultValue=""
                    rules={{ required: true }}
                    render={({ field }) => (
                      <SelectBox
                        label="Status"
                        placeholder="Status"
                        list={statusList}
                        isEdit={isEdit}
                        {...field}
                        error={errors.producStatus}
                        messages={{
                          required: "Status is required",
                        }}
                      />
                    )}
                  />
                </div>
                {/* <div className={`${classes.formField} !mb-5`}>
                  <Controller
                    name="applicationStatus"
                    control={formMethods?.control}
                    defaultValue={[]}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <SelectBox
                        label="Application ID"
                        placeholder="Application ID"
                        list={applicationOptions || []}
                        isEdit={isEdit}
                        multiple
                        {...field}
                        error={errors.applicationStatus}
                        messages={{
                          required: "Application ID is required",
                        }}
                      />
                    )}
                  />
                </div> */}
                <div className={`${classes.formField} !mb-5`}>
                  <InputBox
                    label={"Description"}
                    className={`w-[100%] ${classes.notesInput}`}
                    name={"description"}
                    type={"textarea"}
                    {...register("description", {
                      required: true,
                    })}
                    placeholder={"Description"}
                    error={errors.description}
                    messages={{
                      required: "Description is required",
                    }}
                    isEdit={isEdit}
                  />
                </div>
                <div className={`${classes.formField} !mb-5`}>
                  <FileUpload
                    name="uploadResource"
                    className={`p-4 w-[100%]`}
                    control={formMethods.control}
                    setValue={formMethods.setValue}
                    clearErrors={formMethods.clearErrors}
                    setError={formMethods.setError}
                    error={errors.uploadResource}
                    messages={{
                      required: "Resource file is required",
                    }}
                    maxSize={20971520}
                    maxLable= "20MB"
                    label="Upload File"
                    acceptFiles="video/mp4, video/avi, video/mkv, video/mov, video/wmv, video/flv, application/pdf"
                    fileNames={fileName}
                    setFileName={setFileName}
                    uploadedFiles={uploadedFiles}
                    setUploadedFiles={setUploadedFiles}
                    isFileUploading={isFileUploading}
                    placeholder="Upload File (Max: 20 MB)"
                  // multiple={true}
                  />
                </div>
                <div className={classes.buttonColor}>
                  {tagsList?.map(({ label, value }) => (
                    <div
                      className={`${classes.successRole} ${selectedButton?.includes(value) ? classes.selected : ""} mr-3`}
                      onClick={() => handleButtonClick(value)}
                    >
                      {label}
                    </div>
                  ))}
                </div>
                <div className="flex justify-end">
                  <Button
                    text={"Upload"}
                    className={`w-[100%] my-4`}
                    smallBtn
                  />
                </div>
              </form>
            </FormProvider>
          </div>
        </div>
      </ModalDropdown>
    </>
  );
};

export default UploadResources;
